import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, CircularProgress } from "@mui/material";
import { getProcurementDetail } from "../../api/biomassProcurement";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../components/Alert";
import CustomAppBar from "../../components/AppBar";
import ProcurementDetailCard from "../../components/Biochar/ProcurementDetailCard";

const ProcurementDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [procurement, setProcurement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProcurementDetails();
  }, []);

  const fetchProcurementDetails = async () => {
    try {
      const response = await getProcurementDetail(id);
      console.log("Procurement details:", response);
      setProcurement(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching procurement details:", error);
      showAlert("error", "Failed to fetch procurement details");
      setLoading(false);
    }
  };

  return (
    <>
      <CustomAppBar />
      {loading ? (
        <CircularProgress />
      ) : procurement ? (
        <ProcurementDetailCard procurement={procurement} />
      ) : (
        <Typography variant="h6">{t("Procurement not found")}</Typography>
      )}
    </>
  );
};

export default ProcurementDetail;
